import Swiper, { Pagination, Autoplay } from 'swiper';

Swiper.use([Pagination, Autoplay]);

export default (initialPaginate = false, initalLoop = true, initialAutoPlay = false) => ({
    
    loop: initalLoop,
    paginate: initialPaginate,
    autoPlay: initialAutoPlay,

    init() {

        let config = {
            slidesPerView: 'auto'
        };
        
        if(this.loop){
            config.loop = true;
        }

        if(this.paginate){
            config.pagination = {
                el: this.$refs.pagination
            }
        }

        if(this.autoPlay){
            config.autoplay = true
        }

        const swiper = new Swiper(this.$refs.swiper, config);
        
    }

})